import React from "react";

const ModalContext = React.createContext({
    open: false,
    handleOpen: () => {},
    handleClose: () => {}
});

export default ModalContext;